import { render, staticRenderFns } from "./MemberChangeRoleModal.vue?vue&type=template&id=2205970d&"
import script from "./MemberChangeRoleModal.vue?vue&type=script&lang=js&"
export * from "./MemberChangeRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports